import { TIMELINE_HEIGHT, TIMELINE_TITLE_HEIGHT } from '../constants';

// Dynamic styles function to handle theme-aware styling
export const getTimelineStyles = (theme, height = TIMELINE_HEIGHT) => {
    // Define all dimensions as proportions of the timeline height
    const titleHeight = TIMELINE_TITLE_HEIGHT;
    const thumbnailHeight = Math.floor(height * 0.7); // 70% of timeline height
    const insertZoneWidth = Math.floor(height * 0.3); // 30% of timeline height
    const insertZoneHoverWidth = Math.floor(height * 0.4); // 40% of timeline height
    const endDropZoneWidth = Math.floor(height * 0.8); // 80% of timeline height
    const padding = Math.floor(height * 0.01); // 1% padding
    const smallPadding = Math.floor(height * 0.005); // 0.5% padding for compact spacing
    const borderRadius = Math.floor(height * 0.01); // 1% border radius

    return {
        timelineContainer: {
            position: 'fixed',
            left: 0,
            right: 0,
            // backgroundColor: theme.palette.background.paper,
            borderTop: `1px solid ${theme.palette.divider}`,
            overflowX: 'auto',
            overflowY: 'hidden',
            zIndex: theme.zIndex.appBar,
            transition: 'background-color 0.3s, outline 0.3s'
        },
        dropTarget: {
            backgroundColor: `${theme.palette.action.hover} !important`,
            outline: `2px dashed ${theme.palette.primary.main}`,
        },
        timelineItem: {
            minWidth: `${Math.floor(height * 1.2)}px`, // 120% of timeline height
            borderRight: `1px solid ${theme.palette.divider}`,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            p: padding,
            position: 'relative',
            cursor: 'pointer',
            '&:hover': {
                backgroundColor: theme.palette.action.hover,
            }
        },
        removeButton: {
            position: 'absolute',
            top: 0,
            right: 0,
            display: 'none',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: `${Math.floor(height * 0.015)}rem`, // 0.7rem scaled
            cursor: 'pointer',
            zIndex: 10, // Ensure it's above the thumbnail
        },
        thumbnail: {
            height: `${thumbnailHeight}px`,
            width: 'auto',
            maxWidth: `${Math.floor(height * 1.1)}px`, // 110% of timeline height
            objectFit: 'cover',
            borderRadius: borderRadius,
            mb: smallPadding
        },
        emptyStateMessage: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            pt: padding
        },
        insertDropZone: {
            width: `${insertZoneWidth}px`,
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            // backgroundColor: theme.palette.action.hover,
            transition: 'all 0.3s ease',
            cursor: 'pointer',
            '&:hover': {
                backgroundColor: theme.palette.action.selected,
                width: `${insertZoneHoverWidth}px`,
                borderLeft: `2px dashed ${theme.palette.primary.light}`,
                borderRight: `2px dashed ${theme.palette.primary.light}`,
            },
            '&.drag-over': {
                backgroundColor: `${theme.palette.action.selected} !important`,
                width: `${insertZoneHoverWidth}px`,
                borderLeft: `2px dashed ${theme.palette.primary.main}`,
                borderRight: `2px dashed ${theme.palette.primary.main}`,
            }
        },
        insertIndicator: {
            display: 'none',
            color: theme.palette.primary.main,
            opacity: 0.7,
            '&.visible': {
                display: 'block',
                animation: 'pulse 1.5s infinite',
            }
        },
        timelineContent: {
            display: 'flex',
            minWidth: 'max-content',
            height: '100%',
            paddingTop: `${padding}px`,
            backgroundColor: 'black',
        },
        endDropZone: {
            minWidth: `${endDropZoneWidth}px`,
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'background-color 0.2s',
            '&.drag-over': {
                backgroundColor: theme.palette.action.selected,
            }
        },
        titleHeight: titleHeight,
        textPreviewMaxWidth: `${Math.floor(height)}px`, // 100% of timeline height
        topPosition: Math.floor(height * 0.05), // 5% of timeline height
        leftPosition: Math.floor(height * 0.1), // 10% of timeline height
        fontSize: {
            small: `${Math.floor(height * 0.0065)}rem`, // 0.65rem scaled
        },
        padding: padding,
        smallPadding: smallPadding
    }
};